import { useTranslation } from '@eti/providers';
import { Inline, Stack, Text, textVariants } from '@etg/wings';
import type { ScheduleType } from './models';

interface CommunicationScheduleProps {
  schedule: ScheduleType[];
  isChatSchedule: boolean;
}
const ContactSchedule = ({ schedule, isChatSchedule }: CommunicationScheduleProps) => {
  const { t } = useTranslation();

  return (
    <Stack data-testid="schedule-section" spacing={8}>
      <>
        <Text variant={textVariants._14_BOLD}>
          {t('ContactUs.ContactSection.LocalLanguageSchedule.Title')}
        </Text>
        {schedule.map((item, index) => (
          <Inline data-testid={`schedule-${index}`} key={`schedule-${index}`} spacing={0}>
            <Text>{item.startDay}</Text>
            {item.endDay !== item.startDay && <Text>{`-${item.endDay}`}</Text>}
            <Text>{`: ${item.startTime}`}</Text>
            <Text>{`-${item.endTime}`}</Text>
          </Inline>
        ))}
        {!isChatSchedule && (
          <Text data-testid="contact-schedule-exception">
            {t('ContactUs.ContactSection.ScheduleException')}
          </Text>
        )}
      </>
    </Stack>
  );
};

export default ContactSchedule;
